import React, { useState, useEffect } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';
import withFeatureFlags from "../FeatureFlags/withFeatureFlags";

/** @import {ResendOtpProps} from './ResendOtpTypes' */
/** @import {WithFeatureFlagsProps} from '../FeatureFlags/FeatureFlagsTypes' */

import chevRight from '../../assets/images/chev-right-royal.svg';
import {useUnifiedAnalytics} from "../../contexts/AnalyticsWrapper";

function ResendOtp(/** @type {WithFeatureFlagsProps & ResendOtpProps} */ props) {
  const RESEND_OTP = gql`
      mutation ResendOtp($request : ResendOtpRequestType!){
      resendOtp(request:$request) {
        success
      }
    }  
  `;

  const SEND_VOICE_OTP = gql`
      mutation SendVoiceOtp($request : SendVoiceOtpRequestType!){
      sendVoiceOtp(request:$request) {
        success
      }
    }  
  `;


  const analytics = useUnifiedAnalytics();

  const [hideResendLink, setHideResendLink] = useState(false);
  const [resendCount, setResendCount] = useState(0);
  const [tick, setTick] = useState(30);
  const [startTick, setStartTick] = useState(false);
  const [maxResendsSent, setMaxResendsSent] = useState(false);
  const [sendMode, setSendMode] = useState('sms');
  const [firstVoiceCall, setFirstVoiceCall] = useState(true);

  const [resendOtp] = useMutation(RESEND_OTP);
  const [sendVoiceOtp] = useMutation(SEND_VOICE_OTP);

  useEffect(() => {
    // exit early when we reach 0
    if (!tick || !startTick || resendCount === 4) {
      setStartTick(false);
      setTick(30);
      setHideResendLink(false);

      if (props.isResendingCallback) {
        props.isResendingCallback(false);
      }

      return;
    }

    if (tick === 1) {
      resendClientOtp();
      if (resendCount === 3) {
        setMaxResendsSent(true);
      }
    }

    // save intervalId to clear the interval when the
    // component re-renders
    const intervalId = setInterval(() => {
      setTick(tick - 1);
    }, 1000);

    // clear interval on re-render to avoid memory leaks
    return () => clearInterval(intervalId);
    // add timeLeft as a dependency to re-rerun the effect
    // when we update it
  }, [tick, startTick]);

  const resendClicked = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ _event) => {
    resend();
  };
  
  const resend = () => {
    setResendCount(resendCount + 1);
    setStartTick(true);
    setHideResendLink(true);

    if (props.isResendingCallback) {
      props.isResendingCallback(true);
    }
  }
 
  const resendViaVoiceClicked = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) => {
    event.preventDefault();
    setFirstVoiceCall(false);
    props.isNoticeWithdrawal ?
        analytics.trackAnalyticsOtpEvent(
            "call me instead",
            "dashboard",
            "ns withdrawal",
            "notice-saver",
            "otp|call me instead|ns withdrawal"
        ) :
        analytics.trackAnalyticsOtpEvent(
            "resend one-time password via voice instead?",
            "dashboard",
            "voice",
            "notice-saver",
            "otp|resend|voice"
        );
    setSendMode('voice');
    props.onModeChanged && props.onModeChanged('voice');
    resend();
  }
 
  const resendViaSmsClicked = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) => {
    event.preventDefault();

    props.isNoticeWithdrawal ?
        analytics.trackAnalyticsOtpEvent(
            "resend one-time password",
            "dashboard",
            "ns withdrawal",
            "notice-saver",
            "otp|resend|ns withdrawal"
        )
        :
        analytics.trackAnalyticsOtpEvent(
            "resend one-time password via sms instead?",
            "dashboard",
            "sms",
            "notice-saver",
            "otp|resend|sms"
        );    
    setSendMode('sms');
    props.onModeChanged && props.onModeChanged('sms');
    resend(); // resendClientOtp();
  }
  
  const sendViaVoice = async () => {
    await sendVoiceOtp({
      variables: {
        request: {
          verificationToken: props.verificationToken,
        }
      }
    });
  }

  const sendViaSms = async () => {
    await resendOtp({
      variables: {
        request: {
          verificationToken: props.verificationToken
        }
      }
    });
  }
  
  const resendClientOtp = async () => {
    // analytics.trackAnalyticsOtpEvent("resend one-time password?", props.analyticsRegion || 'unknown', props.analyticsAction || 'unknown')
    if (sendMode === 'sms') {
      await sendViaSms();
    } else {
      await sendViaVoice();
    }
  }

  const renderMaxRetries = () => {
    return <span className={props.counterClassName}><b>One-time password sent. You've now sent the maximum number of one-time passwords.</b></span>;
  };

  const getVoiceText = () => {
    return firstVoiceCall ? "Call me instead" : "Call me again";
  }

  const render = () => {
    if (maxResendsSent) {
      return renderMaxRetries();
    }
    
    if (hideResendLink) {
      return <span className={props.counterClassName}><b>Sending new one-time password in {tick} second{tick !== 1 ? 's' : '' }.</b></span>
    }

    if (props.featureEnabled('voice_otp')) {
      return (<>
        {/*{!didntReceiveIt && <a href="#" className={props.linkClassName} onClick={() => setDidntReceiveIt(true)}>Didn't receive it? <img src={chevRight} /></a>}*/}
        {/*{didntReceiveIt && */}
        {/* (<>*/}
        {/*  <div>*/}
        {/*  <a href="#" className={props.linkClassName} onClick={resendClicked}>Text me another one-time password<img src={chevRight} /></a>*/}
        {/*  </div>*/}
        <div>         
          <a href="#" className={props.linkClassName} onClick={resendViaSmsClicked}>Text me another one-time
            passcode<img src={chevRight} /></a>
        </div>
            <div>
              <a href="#" className={props.linkClassName} onClick={resendViaVoiceClicked}>{getVoiceText()}<img src={chevRight} /></a>
        </div>
        {/*</>)*/}
        {/* }*/}
          </>
      ); 
    } else {
      return <a href="#" className={props.linkClassName} onClick={resendClicked}>Resend one-time password <img src={chevRight}/></a>;
    }
  };

  return render();
};

export default withFeatureFlags(ResendOtp);